module.exports = __webpack_public_path__ + "static/img/Ellipse 119.22ecf8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Ellipse 119.png
// module id = +6WM
// module chunks = 1